import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconDownload = deprecatedComponent({
    displayName: 'IconDownload',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.13322 1.43335C8.40936 1.43335 8.63322 1.65721 8.63322 1.93335V9.52621L10.7797 7.37976C10.9749 7.1845 11.2915 7.1845 11.4868 7.37976C11.682 7.57503 11.682 7.89161 11.4868 8.08687L8.48677 11.0869C8.29151 11.2821 7.97493 11.2821 7.77967 11.0869L4.77967 8.08687C4.5844 7.89161 4.5844 7.57503 4.77967 7.37976C4.97493 7.1845 5.29151 7.1845 5.48677 7.37976L7.63322 9.52621V1.93335C7.63322 1.65721 7.85708 1.43335 8.13322 1.43335ZM1.56665 14.0667C1.56665 13.7905 1.79051 13.5667 2.06665 13.5667H14.0667C14.3428 13.5667 14.5667 13.7905 14.5667 14.0667C14.5667 14.3428 14.3428 14.5667 14.0667 14.5667H2.06665C1.79051 14.5667 1.56665 14.3428 1.56665 14.0667Z",
            fill: "black"
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconDownload };
